export const actionTypes = {
  GET_RECIPES: 'recipes/getRecipes',
  ADD_RECIPE: 'recipes/addRecipe',
  DELETE_RECIPE: 'recipes/deleteRecipe',
  DELETE_RECIPES: 'recipes/deleteRecipes',
  FILTER_RECIPE: 'recipes/filterRecipe',
  UPDATE_RECIPE: 'recipes/updateRecipe'
};
